<template>
<div :class="{ 'modal-mode': isInModal }">
  <!-- Loading State -->
   <div v-if="isLoading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
  <!-- Error State -->
  <div v-else-if="error" class="error-container">
    <h2>{{ error }}</h2>
    <p>The product you're looking for could not be found.</p>
    <router-link to="/home" class="button">Return Home</router-link>
  </div>
  <!-- Product Content -->
  <div v-else-if="product">
    <!-- Promo Section - Hidden in modal mode -->
    <section v-if="showFooter" class="promo-section"></section>
    <!-- Navigation Section - Hidden in modal mode -->
    <section v-if="showFooter" id="navtest" class="nav nscrtest">
      <div class="promo-div">
        <div class="promo-box">
          <div class="text-block-775"><span class="text-span-181">LIMITED TIME: </span>FREE OVERNIGHT SHIPPING & DOCTOR REVIEW</div>
        </div>
      </div>
      <div class="nav-holder-div">
        <div class="nav-bar-div weight hide-block w-clearfix">
          <a href="#" class="brand w-nav-brand">
            <img sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="nav-logo">
          </a>
          <div class="div-block-1714">
            <a href="register.html" class="link-block-51 w-inline-block"></a>
            <a href="#" class="link-block-68 w-inline-block" @click.prevent="toggleCart">
              <img loading="lazy" src="@/assets/images/icon_-cart.svg" alt="" class="image-422">
              <div class="div-block-1788" v-if="cartItemCount > 0">
                <div class="text-block-859">{{ cartItemCount }}</div>
              </div>
            </a>
            <div data-animation="over-right" data-collapse="all" data-duration="400" data-easing="ease" data-easing2="ease" data-doc-height="1" role="banner" class="navbar w-nav">
              <div class="menu-button w-nav-button" @click="toggleMobileMenu">
                <div class="icon-28 w-icon-nav-menu"></div>
              </div>
              
            </div>
          </div>
        </div>
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-3 w-nav">
          <router-link to="/" class="brand-4 w-nav-brand">
            <img sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="nav-logo weight">
          </router-link>
        </div>
      </div>
    </section>
    <!-- Product Section -->
    <section class="product-section">
      <div class="product-div-wrap">
        <div class="product-div-box">
          <!-- Product Images -->
          <div class="product-images-div">
            <div data-delay="4000" data-animation="slide" class="product-slider w-slider" data-autoplay="false" data-easing="ease" data-hide-arrows="false" data-disable-swipe="false" data-autoplay-limit="0" data-nav-spacing="3" data-duration="500" data-infinite="true" id="product-slider">
              <div :class="['mask-13', 'w-slider-mask', { 'mobile-scroll': isMobile }]" :style="{ overflow: isMobile ? 'visible' : 'hidden' }" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
                <div class="slides-container" :style="{ transform: slideTransform, transition: isDragging ? 'none' : 'transform 0.5s ease-in-out' }">
                  <div v-for="(img, index) in productImages" :key="`slide-${index}`" :id="`slide-${index + 1}`" :class="['product-slide', 'template', 'w-slide', { 'w-active': currentImageIndex === index }]" :style="!isMobile ? { minWidth: '100%', flexShrink: 0 } : {}">
                    <a href="#" class="lightbox-link w-inline-block w-lightbox" @click.prevent="openLightbox(index)">
                      <div class="product-img-div template">
                        <img :src="img.url" loading="lazy" :alt="img.alt || ''" class="slideimg template">
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="product-slider-left-arrow w-slider-arrow-left" @click.prevent="previousImage">
                <div class="product-slider-arrow-icon w-icon-slider-left"></div>
              </div>
              <div class="product-slider-right-arrow w-slider-arrow-right" @click.prevent="nextImage">
                <div class="product-slider-arrow-icon w-icon-slider-right"></div>
              </div>
              <div class="slide-nav-4 w-slider-nav w-round w-num">
                <div v-for="(_, index) in productImages" :key="`nav-${index}`" :class="['w-slider-dot', { 'w-active': currentImageIndex === index }]" @click="goToImage(index)"></div>
              </div>
            </div>
            <div class="category">{{ product.category?.primary || 'WEIGHT' }}</div>
            <div class="img-links-div">
              <div class="div-block-2154">
                <a v-for="(img, index) in productImages" :key="`gallery-${index}`" :href="`#slide-${index + 1}`" :class="`gallery-link${index + 1} w-inline-block`" @click.prevent="goToImage(index)">
                  <img :src="img.url" loading="lazy" :alt="img.alt || ''" >
                </a>
              </div>
            </div>
          </div>
          <!-- Product Details -->
          <div class="product-detail-div">
            <div :class="`category_mobile ${(product.category?.primary || 'weight').toLowerCase()}`">
              {{ product.category?.primary || 'WEIGHT' }}
            </div>
            <div class="ratings-div"><img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-394">
            <div class="trustpilot-rating-div">
                <div class="trustpilot-rating-text">Excellent</div>
                <div class="trustpilot-score-text">4.6 out of 5</div><img src="images/Trustpilot_Logo_2022.svg.webp" loading="lazy" sizes="(max-width: 479px) 100vw, 240px" srcset="images/Trustpilot_Logo_2022.svg-p-500.png 500w, images/Trustpilot_Logo_2022.svg-p-800.png 800w, images/Trustpilot_Logo_2022.svg-p-1080.png 1080w, images/Trustpilot_Logo_2022.svg.webp 2560w" alt="" class="trustpilot-rating-logo">
              </div>
            </div>
            <div class="product-name-box">
              <div class="product-name">{{ product.name }}</div>
              <div class="text-block-866">{{ product.brand_name || 'Compound Medication' }}</div>
            </div>
            <div class="product-price-div" v-if="showFooter">
              <div class="old-price-text">${{ oldPrice }}</div>
              <div class="price-text">${{ currentPrice }}</div>
              <div>
                <div class="savings-text">{{ savingsText }}</div>
              </div>
            </div>
            
            <div class="line-divider"></div>
            <div class="description-header-text">{{ product.marketing?.sub_header || '' }}</div>
            <p class="paragraph-169">{{ product.marketing?.description || '' }}</p>
            <div class="prod-bullets-div sales" v-if="product.product_bullets && product.product_bullets.length">
              <div v-for="(bullet, index) in product.product_bullets" :key="`bullet-${index}`" :class="['prod-bullet', { 'bottom': index === product.product_bullets.length - 1 }]">
                <img :src="bullet.icon || require('@/assets/images/icon_check_LGreenBlkoutline.svg')" loading="lazy" alt="" class="image-568">
                <div class="text-block-1329" v-html="bullet.text || bullet"></div>
              </div>
            </div>
            <div class="line-divider"></div>
            <div class="div-block-1796 hide">
              <a href="#" class="link-block-69 w-inline-block">
                <img src="@/assets/images/icon_chat_grn.svg" loading="lazy" alt="" class="image-427">
                <div>Ask A Question</div>
              </a>
              <a href="#" class="link-block-69 w-inline-block">
                <img src="@/assets/images/icon_read_grn.svg" loading="lazy" alt="" class="image-427">
                <div>Read Article</div>
              </a>
            </div>

            <!-- Pricing Selection -->
            <div class="product-form w-form" v-if="availablePlans.length > 0 && showButtons">
              <form id="email-form" name="email-form" data-name="Email Form" method="get" aria-label="Email Form" @submit.prevent>
                <div class="med-type-div-copy left-align">
                  <template v-if="availablePlans.length > 2">
                    <div class="text-block-1776">Choose Medication</div>
                    <div class="supply-choice-div">
                      <div class="div-block-2295">
                        <div class="div-block-2293">
                          <label class="radio-button-field-5 w-radio">
                            <input type="radio" name="supply-radio" id="supply-monthly" data-name="Supply Radio" class="w-form-formradioinput radio-button-5 w-radio-input" value="monthly" v-model="selectedSupply">
                            <span class="radio-button-label-9 hide w-form-label" for="supply-monthly">Monthly</span>
                            <div class="text-block-1789 hide">Easy Application</div>
                            <div class="div-block-2294">
                              <div class="text-block-1788">Monthly Supply</div>
                            </div>
                          </label>
                          <div class="popup-text-4">The easiest routine to stick with daily if you don't like needles.</div>
                        </div>
                        <div class="div-block-2293">
                          <label class="radio-button-field-5 w-radio">
                            <input type="radio" name="supply-radio" id="supply-3month" data-name="Supply Radio" class="w-form-formradioinput radio-button-5 w-radio-input" value="3month" v-model="selectedSupply">
                            <span class="radio-button-label-9 hide w-form-label" for="supply-3month">3-Month</span>
                            <div class="text-block-1781-copy-2 hide">Highest Efficacy</div>
                            <div class="div-block-2294">
                              <div class="text-block-1788">3-Month Supply</div>
                            </div>
                          </label>
                          <div class="popup-text-3">Instant energy upgrade felt throughout the day without effecting sleep.</div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="text-block-1776 plan">Choose Payment Plan</div>
                </div>
                <div class="_3-button-div">
                  <div v-for="plan in availablePlans" :key="plan.plan_id" class="upsell_option">
                    <label class="payplan-choice w-radio" :class="{ 'selected': selectedPlanId === plan.plan_id }">
                      <input type="radio" data-name="Radio" :id="'plan-' + plan.plan_id" name="radio" class="w-form-formradioinput radio-button-4 w-radio-input" :value="plan.plan_id" v-model="selectedPlanId">
                      <span class="radio-button-label-7 w-form-label" :for="'plan-' + plan.plan_id">Radio</span>
                      <div class="div-block-2282">
                        <div class="div-block-2280">
                          <div class="month-text">{{ getPlanTitle(plan) }}</div>
                          <p class="paragraph-230">{{ getPlanSubtitle(plan) }}</p>
                        </div>
                        <div class="plan-price-box">
                          <div class="payplan-price" v-if="plan.terms === 1"><span class="text-span-442"><sup class="price-cents">$</sup></span>{{ formatPriceDollars(plan.price) }}<sup class="price-cents prod">{{ formatPriceCents(plan.price) }}</sup><span class="text-span-440">/mo</span></div>
                          <div class="payplan-price" v-if="plan.terms === 3"><span class="text-span-442"><sup class="price-cents">$</sup></span>{{ formatPriceDollars(plan.price / 3) }}<sup class="price-cents prod">{{ formatPriceCents(plan.price / 3) }}</sup><span class="text-span-440">/mo Avg.</span></div>
                          <div class="text-block-1775" v-if="plan.terms === 1">1 Month Supply</div>
                          <div class="text-block-1775" v-if="plan.terms === 3">Pay <strong>${{ plan.price.toFixed(2) }}</strong> Today<br><span class="text-span-441">Save ${{ calculateSavings(plan) }}!</span></div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </form>
              
            </div>

            <div v-if="showButtons" class="new-cart-button" @click="handleAddToCart">
              <div class="cart-icon-div-2">
                <div class="code-embed-3-copy w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewBox="0 0 16 16">
                    <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                  </svg>
                </div>
              </div>
              <div>ADD TO CART</div>
              <div class="button-price">- ${{ formatPriceDollars(parseFloat(currentPrice)) }}<span><sup class="superscript-18">.{{ formatPriceCents(parseFloat(currentPrice)) }}</sup></span></div>
            </div>

            <div class="perks-div">
              <div class="perk-div ship">
                <img src="@/assets/images/icon_shipping.svg" loading="lazy" alt="" class="image-386">
                <div class="text-block-738"><strong>Overnight </strong>Shipping</div>
              </div>
              <div class="perk-div sema">
                <img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-386 refund">
                <div class="text-block-738"><strong>Full Refund </strong>if Declined By Doctor</div>
              </div>
            </div>
            <div class="div-block-2302">
              <img src="@/assets/images/Payment_Methods.webp" loading="lazy" alt="" class="image-399">
            </div>
            <div class="order-arival-div">
              <img src="@/assets/images/icon__Alert-dot.svg" loading="lazy" alt="" class="image-396">
              <div class="text-block-770" v-html="`Order today and get it by <strong>${futureDate}</strong>`"></div>
            </div>
            <div class="delivery-disclaimer">*Mon - Thursday Overnight Shipping (Not on Weekends)</div>

            <div class="mobile-lightbox-div" v-if="productImages.length > 1">
              <div class="lightbox-row">
                <a v-for="(img, index) in productImages.slice(1, 3)" :key="`mobile-1-${index}`" href="#" class="w-inline-block w-lightbox" @click.prevent="openLightbox(index + 1)">
                  <img :src="img.url" loading="lazy" :alt="img.alt">
                </a>
              </div>
              <div class="lightbox-row">
                <a v-for="(img, index) in productImages.slice(3, 5)" :key="`mobile-2-${index}`" href="#" class="w-inline-block w-lightbox" @click.prevent="openLightbox(index + 3)">
                  <img :src="img.url" loading="lazy" :alt="img.alt">
                </a>
              </div>
            </div>
            <div class="div-block-2302">
            <div class="dropdowns-set-adjust-div" v-if="product.dropdowns && product.dropdowns.length">
              <div v-for="(dropdown, index) in product.dropdowns" :key="`dropdown-${index}`" data-delay="0" data-hover="false" class="description-dropdown w-dropdown">
                <div class="dropdown-toggle-5 w-dropdown-toggle" @click="toggleDropdown(index)">
                  <div class="icon-26 w-icon-dropdown-toggle"></div>
                  <div class="dropdown-header">{{ dropdown.header }}</div>
                </div>
                <nav :class="['dropdown-list-3', 'w-dropdown-list', { 'w--open': openDropdown === index }]">
                  <div class="w-form">
                    <form class="form-9">
                      <div>
                        <p class="paragraph-131" v-html="dropdown.text"></p>
                      </div>
                    </form>
                  </div>
                </nav>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Highlights Section -->
    <section v-if="product.highlights">
      <div class="highlights_wrap">
        <div class="highlight-div">
          <div class="highlights_flex">
            <div class="highlights_text_div">
              <h1 class="highlights-heading">{{ product.highlights.heading }}</h1>
              <p class="paragraph-198">{{ product.highlights.description }}</p>
            </div>
            <div class="highlights_imgdiv">
              <div class="feature-div top">
                <div class="text-block-1577" v-html="product.highlights.features[0]"></div>
              </div>
              <div class="img-flex-div">
                <div class="div-block-2156">
                  <div class="feature-div">
                    <div class="text-block-1577" v-html="product.highlights.features[1]"></div>
                  </div>
                  <div class="feature-div">
                    <div class="text-block-1577" v-html="product.highlights.features[2]"></div>
                  </div>
                </div>
                <div class="hl_prodimgdiv">
                  <img :src="product.highlights.image" loading="lazy" alt="">
                </div>
                <div class="div-block-2156">
                  <div class="feature-div">
                    <div class="text-block-1577" v-html="product.highlights.features[3]"></div>
                  </div>
                  <div class="feature-div">
                    <div class="text-block-1577" v-html="product.highlights.features[4]"></div>
                  </div>
                </div>
              </div>
              <a v-if="showButtons" href="#" class="button-161 w-button" @click.prevent="handleAddToCart">Add To Cart</a>
              <p class="paragraph-199" v-if="product.highlights.disclaimer">{{ product.highlights.disclaimer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Dropdowns Section -->
    <section class="dropdowns-section" v-if="product.dropdowns && product.dropdowns.length">
      <div class="dropdowns-div-wrap">
        <div class="drpdwn-lightbox-div">
          <div class="lightbox-div">
            <div class="lightbox-row-div"></div>
          </div>
          <div class="dropdowns-wrapper">
            <div class="dropdowns-set-adjust-div">
              <div v-for="(dropdown, index) in product.dropdowns" :key="`desktop-dropdown-${index}`" data-delay="0" data-hover="false" class="description-dropdown w-dropdown">
                <div class="dropdown-toggle-5 w-dropdown-toggle" @click="toggleDropdownDesktop(index)">
                  <div class="icon-26 w-icon-dropdown-toggle"></div>
                  <div class="dropdown-header">{{ dropdown.header }}</div>
                </div>
                <nav :class="['dropdown-list-3', 'w-dropdown-list', { 'w--open': openDropdownDesktop === index }]">
                  <div class="w-form">
                    <form class="form-9">
                      <div>
                        <p class="paragraph-131" v-html="dropdown.text"></p>
                      </div>
                    </form>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- How It Works Section -->
    <section class="how-it-works-section">
    <div class="how-it-works-wrap">
      <div class="_4things-div">
        <div class="text-block-829">How It Works</div>
        <p class="paragraph-130">No Insurance Needed. All Online.<br></p>
        <div class="div-block-2158">
          <div class="hiw_-stack">
            <div class="hiw_grid-pair-div hide-flex">
              <div class="div-block-2023">
                <div class="hiwg_box-img"><img src="images/HIW_Quiz.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="images/HIW_Quiz-p-500.webp 500w, @/assets/images/HIW_Quiz-p-800.webp 800w, @/assets/images/HIW_Quiz.webp 1080w" alt="" class="hiw-img _1"></div>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">1</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Fill Out Short Quiz to<br>Pre-Qualify.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
              </div>
              <div class="div-block-2023">
                <div class="hiwg_box-img _2"><img src="images/HIW_call.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="images/HIW_call-p-500.webp 500w, @/assets/images/HIW_call-p-800.webp 800w, @/assets/images/HIW_call.webp 1080w" alt="" class="hiw-img _2"></div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">2</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Meet with Doc by<br>Chat or Video.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="hiw_grid-pair-div bottom hide-flex">
              <div class="div-block-2023">
                <div class="hiwg_box-img"><img src="@/assets/images/HIW_Deliver.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/HIW_Deliver-p-500.webp 500w, @/assets/images/HIW_Deliver-p-800.webp 800w, @/assets/images/HIW_Deliver.webp 1080w" alt="" class="hiw-img _3"></div>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">3</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Meds Shipped at<br>Door in 3 Days.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
              </div>
              <div class="div-block-2023">
                <div class="hiwg_box-img _4"><img src="@/assets/images/HIW_support.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="images/HIW_support-p-500.webp 500w, @/assets/images/HIW_support-p-800.webp 800w, @/assets/images/HIW_support.webp 1080w" alt="" class="hiw-img _4"></div>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">4</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Follow Personalized<br>Weight Plan.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
              </div>
            </div>
            <div class="process-box-copy">
              <div class="process-flex">
                <div class="process-flex-left">
                  <div class="step-image-box"><img src="@/assets/images/WeightSteps_QuizFlip.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="images/WeightSteps_QuizFlip-p-500.webp 500w, @/assets/images/WeightSteps_QuizFlip-p-800.webp 800w, @/assets/images/WeightSteps_QuizFlip.webp 1080w" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header _1">Fill Out Short Quiz<br></div>
                    <div class="process-step-sub">Get pre-qualified for free in 2 minutes.</div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">1</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">5 mins</div>
            </div>
            <div class="process-box-copy">
              <div class="process-flex">
                <div class="process-flex-left">
                  <div class="step-image-box"><img src="@/assets/images/WeightSteps_Teledoc.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="images/WeightSteps_Teledoc-p-500.webp 500w, @/assets/images/WeightSteps_Teledoc-p-800.webp 800w, @/assets/images/WeightSteps_Teledoc.webp 1080w" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header _2">Meet with Tele-doc<br></div>
                    <div class="process-step-sub">Board Certified Doctors on demand.</div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">2</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">Today</div>
            </div>
            <div class="process-box bottom hide">
              <div class="process-flex">
                <div class="process-flex-left _5">
                  <div class="step-image-box"><img src="@/assets/images/WeightSteps_Lose.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="images/WeightSteps_Lose-p-500.webp 500w, @/assets/images/WeightSteps_Lose-p-800.webp 800w, @/assets/images/WeightSteps_Lose.webp 1080w" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header _5">Lose up to 25% of Body Weight<br></div>
                    <div class="process-step-sub">This is some text inside of a div block.</div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">5</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">text here</div>
            </div>
            <div class="process-box mobile-only hide-block">
              <div class="process-flex">
                <div class="process-flex-left">
                  <div class="step-image-box"><img src="@/assets/images/placeholder_loseweight.webp" loading="lazy" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header mob">Lose Up to 22%<br>of Body Weight<br></div>
                    <div class="process-step-header desk">Follow Personalized Plan<br></div>
                    <div class="process-step-sub">Lorem ipsum dolor sit amet, consectetur &nbsp;elit. </div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">5</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">Feel Results</div>
            </div>
          </div>
          <div class="hiw_-stack">
            <div class="hiw_grid-pair-div hide-flex">
              <div class="div-block-2023">
                <div class="hiwg_box-img"><img src="@/assets/images/HIW_Quiz.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/HIW_Quiz-p-500.webp 500w, @/assets/images/HIW_Quiz-p-800.webp 800w, @/assets/images/HIW_Quiz.webp 1080w" alt="" class="hiw-img _1"></div>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">1</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Fill Out Short Quiz to<br>Pre-Qualify.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
              </div>
              <div class="div-block-2023">
                <div class="hiwg_box-img _2"><img src="@/assets/images/HIW_call.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/HIW_call-p-500.webp 500w, @/assets/images/HIW_call-p-800.webp 800w, @/assets/images/HIW_call.webp 1080w" alt="" class="hiw-img _2"></div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">2</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Meet with Doc by<br>Chat or Video.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="hiw_grid-pair-div bottom hide-flex">
              <div class="div-block-2023">
                <div class="hiwg_box-img"><img src="@/assets/images/HIW_Deliver.webp" loading="lazy" sizes="100vw" srcset="@/assets/images/HIW_Deliver-p-500.webp 500w, @/assets/images/HIW_Deliver-p-800.webp 800w, @/assets/images/HIW_Deliver.webp 1080w" alt="" class="hiw-img _3"></div>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">3</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Meds Shipped at<br>Door in 3 Days.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
              </div>
              <div class="div-block-2023">
                <div class="hiwg_box-img _4"><img src="@/assets/images/HIW_support.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/HIW_support-p-500.webp 500w, @/assets/images/HIW_support-p-800.webp 800w, @/assets/images/HIW_support.webp 1080w" alt="" class="hiw-img _4"></div>
                <div class="div-block-2097">
                  <div class="div-block-2098">
                    <div class="text-block-1440">4</div>
                  </div>
                  <div class="div-block-2100">
                    <div class="text-block-1361">Follow Personalized<br>Weight Plan.</div>
                    <div class="text-block-1447">This is some text inside of a div block.</div>
                  </div>
                </div>
                <p class="paragraph-178 hide">Icon finds winning ad concepts by scanning websites (yours &amp; competitors), competitor ads, customer reviews, ad account performance, &amp; more.</p>
              </div>
            </div>
            <div class="process-box-copy">
              <div class="process-flex">
                <div class="process-flex-left">
                  <div class="step-image-box"><img src="@/assets/images/WeightSteps_deliverscreen-p-800.webp" loading="lazy" sizes="(max-width: 800px) 100vw, 800px" srcset="@/assets/images/WeightSteps_deliverscreen-p-800-p-500.webp 500w, @/assets/images/WeightSteps_deliverscreen-p-800.webp 800w" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header _3">Next Day Shipping<br></div>
                    <div class="process-step-sub">Cold Packed &amp;&nbsp;Ready to use medications.</div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">3</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">Cold Shipped</div>
            </div>
            <div class="process-box-copy">
              <div class="process-flex">
                <div class="process-flex-left">
                  <div class="step-image-box"><img src="@/assets/images/WeightSteps_Plan2.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/WeightSteps_Plan2-p-500.webp 500w, @/assets/images/WeightSteps_Plan2-p-800.webp 800w, @/assets/images/WeightSteps_Plan2.webp 1080w" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header mob">Personalized Plans<br></div>
                    <div class="process-step-header desk">Ongoing Clinical Support<br></div>
                    <div class="process-step-sub">AI support plus real nurses to guide your journey.</div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">4</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">24/7 Support</div>
            </div>
            <div class="process-box bottom hide">
              <div class="process-flex">
                <div class="process-flex-left _5">
                  <div class="step-image-box"><img src="@/assets/images/WeightSteps_Lose.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/WeightSteps_Lose-p-500.webp 500w, @/assets/images/WeightSteps_Lose-p-800.webp 800w, @/assets/images/WeightSteps_Lose.webp 1080w" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header _5">Lose up to 25% of Body Weight<br></div>
                    <div class="process-step-sub">This is some text inside of a div block.</div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">5</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">text here</div>
            </div>
            <div class="process-box mobile-only hide-block">
              <div class="process-flex">
                <div class="process-flex-left">
                  <div class="step-image-box"><img src="@/assets/images/placeholder_loseweight.webp" loading="lazy" alt="" class="process-step-img"></div>
                  <div class="process-box-text-div">
                    <div class="process-step-header mob">Lose Up to 22%<br>of Body Weight<br></div>
                    <div class="process-step-header desk">Follow Personalized Plan<br></div>
                    <div class="process-step-sub">Lorem ipsum dolor sit amet, consectetur &nbsp;elit. </div>
                  </div>
                </div>
                <div class="text-block-141 new">$348</div>
                <div class="process-step-img2-div"><img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="process-step-img2 hide">
                  <div class="text-block-1469">5</div>
                </div>
              </div>
              <a href="#" class="link-block-66 w-inline-block"></a>
              <div class="stepstab-text">Feel Results</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


    <!-- Table Section -->
    <section class="table-section">
      <div class="table-wrap">
        <div class="table-div">
          <div class="table-div-header">
            What sets <span class="text-span-184"><strong class="bold-text-41"><img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" class="image-418-logo"></strong></span> apart
          </div>
          <div class="comparison-table">
            <div class="table-row top">
              <div class="table-entry"></div>
              <div class="ns-column">
                <img src="@/assets/images/NewSelf_Logo.webp" loading="lazy" sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" class="image-418">
              </div>
              <div class="other-column">
                <div class="text-block-845">Competition</div>
              </div>
            </div>
            <div v-for="(feature, index) in comparisonFeatures" :key="`feature-${index}`" class="table-row">
              <div class="table-entry">
                <div class="text-block-846">{{ feature }}</div>
              </div>
              <div class="ns-column">
                <img src="@/assets/images/icon_check_LGreenBlkoutline.svg" loading="lazy" alt="" class="image-419">
              </div>
              <div class="other-column">
                <img src="@/assets/images/icon_check-x.svg" loading="lazy" alt="" class="image-419">
              </div>
            </div>
          </div>
        </div>
        <br/><br/>
        
      </div>

    </section>
    <!-- Footer Section -->
    <footer-section v-if="showFooter" />
  </div>

  <!-- Mobile Lightbox -->
  <div v-if="lightboxOpen" class="mobile-lightbox-overlay" @click.self="closeLightbox">
    <button class="lightbox-close-btn" @click="closeLightbox">&times;</button>
    <div class="lightbox-counter">{{ currentImageIndex + 1 }} / {{ productImages.length }}</div>
    <div class="lightbox-swipe-container"
         @touchstart="handleLightboxTouchStart"
         @touchmove="handleLightboxTouchMove"
         @touchend="handleLightboxTouchEnd">
      <div class="lightbox-slides" :style="{ transform: lightboxTransform, transition: isLightboxDragging ? 'none' : 'transform 0.3s ease-out' }">
        <div v-for="(img, index) in productImages" :key="`lightbox-${index}`" class="lightbox-slide" @click.self="closeLightbox">
          <img :src="img.url" :alt="img.alt || ''" class="lightbox-image">
        </div>
      </div>
    </div>
    <div class="lightbox-dots">
      <span v-for="(_, index) in productImages" :key="`dot-${index}`"
            :class="['lightbox-dot', { active: currentImageIndex === index }]"
            @click="goToImage(index)"></span>
    </div>
  </div>

</div>
</template>

<script>
import { findProductByUrlName, getProductsByCategory, fetchProductsFromServer } from '@/utils/productData'
import { mapGetters, mapActions } from 'vuex'
import FooterElement from '@/components/common/footerElement.vue'

export default {
  name: 'ProductTemplate',

  components: {
    'footer-section': FooterElement
  },

  data() {
    return {
      product: null,
      isLoading: true,
      error: null,
      currentImageIndex: 0,
      lightboxOpen: false,
      openDropdown: null,
      openDropdownDesktop: null,
      mobileMenuOpen: false,
      isMobile: false,
      comparisonFeatures: [
        'Doctor Prescribed Revolutionary Therapies.',
        'Synergistic Supplements for the whole body.',
        'Access to network of nationwide pharmacies.',
        'A.I. Enabled Health Optimization Tools.',
        'Chat & Email Access to Clinical Resources.'
      ],
      // Touch scrolling properties
      touchStartX: 0,
      touchEndX: 0,
      touchStartY: 0,
      isDragging: false,
      dragOffset: 0,
      // Lightbox touch properties
      lightboxTouchStartX: 0,
      isLightboxDragging: false,
      lightboxDragOffset: 0,
      selectedPlanId: null,
      selectedSupply: 'monthly',
      pricingPlans: [
                {
                    "plan_id": "695e9e9b212aecbe412f3aa9",
                    "name": "Metformin",
                    "product": "695e9487212aecbe412f3a9b",
                    "terms": 1,
                    "price": 49.97,
                    "url" : "/product/metformin?show_button=false"
                },
                {
                    "plan_id": "695e9eb1212aecbe412f3aaa",
                    "name": "DHEA",
                    "product": "695e94ad212aecbe412f3a9c",
                    "terms": 1,
                    "price": 59.97,
                    "url" : "/product/dhea?show_button=false"
                },
                {
                    "plan_id": "695e9ed8212aecbe412f3aab",
                    "name": "Low Dose Naltrexone",
                    "product": "695e94e6212aecbe412f3a9d",
                    "terms": 1,
                    "price": 59.97,
                    "url" : "/product/low_dose_naltrexone?show_button=false"
                },
                {
                    "plan_id": "695e9f26212aecbe412f3aac",
                    "name": "GLP Boost Bundle - Monthly (Recurring)",
                    "product": "695e9555212aecbe412f3a9e",
                    "terms": 1,
                    "price": 124.97,
                    "url" : "/product/glp_boost?show_button=false"
                },
                {
                    "plan_id": "695e9f48212aecbe412f3aad",
                    "name": "GLP Boost Bundle - 3 Months Plan",
                    "product": "695e9555212aecbe412f3a9e",
                    "terms": 3,
                    "price": 269.97,
                    "url" : "/product/glp_boost?show_button=false"
                },
                {
                    "plan_id": "695ea0dc212aecbe412f3ab5",
                    "name": "GLP Anti-Nausea - Monthly (Recurring)",
                    "product": "695ea08e212aecbe412f3ab1",
                    "terms": 1,
                    "price": 24.97,
                    "url" : "/product/glp-anti?show_button=false"
                },
                {
                    "plan_id": "696a42293ec59cc4ce33dde3",
                    "name": "Metformin - 3 Months",
                    "product": "695e9487212aecbe412f3a9b",
                    "terms": 3,
                    "price": 99.97,
                    "url" : "/product/metformin?show_button=false"
                },
                {
                    "plan_id": "696a425e3ec59cc4ce33dde4",
                    "name": "DHEA - 3 Months Plan",
                    "product": "695e94ad212aecbe412f3a9c",
                    "terms": 3,
                    "price": 124.97,
                    "url" : "/product/dhea?show_button=false"
                },
                {
                    "plan_id": "696a429b3ec59cc4ce33dde5",
                    "name": "Low Dose Naltrexone - 3 Months Plan",
                    "product": "695e94e6212aecbe412f3a9d",
                    "terms": 3,
                    "price": 134.97,
                    "url" : "/product/low_dose_naltrexone?show_button=false"
                },
                {
                    "plan_id": "696a42df3ec59cc4ce33dde6",
                    "name": "GLP Anti-Nausea - 3 Months Plan",
                    "product": "695ea08e212aecbe412f3ab1",
                    "terms": 3,
                    "price": 39.97,
                    "url" : "/product/glp-anti?show_button=false"
                },
                {
                    "plan_id": "696a43e13ec59cc4ce33ddea",
                    "name": "Sermorelin - Monthly (Recurring)",
                    "product": "696a43b53ec59cc4ce33dde8",
                    "terms": 1,
                    "price": 199.97,
                    "url" : "/product/sermorelin?show_button=false"
                },
                {
                    "plan_id": "696a43fa3ec59cc4ce33ddeb",
                    "name": "Sermorelin - 3 Months Plan",
                    "product": "696a43b53ec59cc4ce33dde8",
                    "terms": 3,
                    "price": 749.91,
                    "url" : "/product/sermorelin?show_button=false"
                },
                {
                    "plan_id": "696a44133ec59cc4ce33ddec",
                    "name": "Sermorelin",
                    "product": "696a43b53ec59cc4ce33dde8",
                    "terms": 1,
                    "price": 235.97,
                    "url" : "/product/sermorelin?show_button=false"
                }
            ],
    }
  },

  computed: {
    ...mapGetters([
      'isCartOpen',
      'cartItemCount'
    ]),

    showFooter() {
      // Hide footer when page is opened in modal (via query param)
      return this.$route.query.modal !== 'true'
    },

    isInModal() {
      // Check if page is opened in modal (via query param)
      return this.$route.query.modal === 'true'
    },

    currentPrice() {
      // Use selected plan price if available
      if (this.selectedPlan) {
        return parseFloat(this.selectedPlan.price).toFixed(2)
      }
      if (!this.product?.pricing?.retail_price) return '0.00'
      return parseFloat(this.product.pricing.retail_price).toFixed(2)
    },

    oldPrice() {
      // Calculate old price based on current price
      const basePrice = this.selectedPlan ? this.selectedPlan.price : this.product?.pricing?.retail_price
      if (!basePrice) return '0.00'
      return (parseFloat(basePrice) * 1.33).toFixed(2)
    },

    savingsText() {
      if (this.selectedPlan) {
        return this.selectedPlan.terms === 1 ? '1 Month Supply' : '3 Month Supply'
      }
      return '3 Month Supply'
    },

    // Check if buttons should be shown based on URL parameter
    showButtons() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('show_button') !== 'false';
    },

    futureDate() {
      const date = new Date()
      date.setDate(date.getDate() + 3)
      const weekday = date.toLocaleDateString('en-US', { weekday: 'short' })
      const month = date.toLocaleDateString('en-US', { month: 'short' })
      const day = date.getDate()
      const suffix = this.getOrdinalSuffix(day)
      return `${weekday}, ${month} ${day}<sup>${suffix}</sup>`
    },

    productImages() {
      // If product has images array, use it
      if (this.product?.images?.length) {
        return this.product.images
      }

      // Otherwise, generate from image_pre_text
      if (this.product?.image_pre_text) {
        const baseUrl = 'https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp'
        const imageCount = 5 // Adjust this based on how many images you have per product

        return Array.from({ length: imageCount }, (_, i) => ({
          url: `${baseUrl}/${this.product.image_pre_text}/${i + 1}.webp`,
          alt: `${this.product.name} - Image ${i + 1}`,
          type: 'image'
        }))
      }

      return []
    },

    currentImage() {
      if (!this.productImages.length) return {}
      return this.productImages[this.currentImageIndex] || {}
    },

    relatedProducts() {
      if (!this.product?.category?.primary) return []
      const allProducts = getProductsByCategory(this.product.category.primary)
      return allProducts.filter(p => p.sku !== this.product.sku).slice(0, 4)
    },

    categoryDisplayName() {
      const category = this.product?.category?.primary || ''
      if (category === 'WEIGHT') return 'Weight Loss'
      return category.charAt(0).toUpperCase() + category.slice(1).toLowerCase()
    },

    slideWidth() {
      // On mobile, each slide is 100% of mask (which is 70% of container)
      // On desktop, slides are 100% of container
      return 100
    },

    slideTransform() {
      if (this.isMobile) {
        // On mobile, transform by 100% + margin (10px) per slide
        // Using calc to handle the 10px margin
        const dragPercentage = this.isDragging ? (this.dragOffset / window.innerWidth) * 100 : 0
        return `translateX(calc(-${this.currentImageIndex * 100}% - ${this.currentImageIndex * 10}px + ${dragPercentage}%))`
      }
      // Desktop: standard percentage-based transform
      const baseTransform = this.currentImageIndex * this.slideWidth
      const dragPercentage = this.isDragging ? (this.dragOffset / window.innerWidth) * 100 : 0
      return `translateX(-${baseTransform - dragPercentage}%)`
    },

    lightboxTransform() {
      const baseTransform = this.currentImageIndex * 100
      const dragPercentage = this.isLightboxDragging ? (this.lightboxDragOffset / window.innerWidth) * 100 : 0
      return `translateX(-${baseTransform - dragPercentage}%)`
    },

    availablePlans() {
      if (!this.product?.id) return []
      return this.pricingPlans.filter(plan => plan.product === this.product.id)
    },

    selectedPlan() {
      if (!this.selectedPlanId) return null
      return this.pricingPlans.find(plan => plan.plan_id === this.selectedPlanId)
    },

    displayTestimonials() {
      // If product has testimonials, use them
      if (this.product?.testimonials?.length) {
        return this.product.testimonials
      }

      // Otherwise, return default testimonials
      return [
        {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.',
          name: 'Tommy J.',
          address: 'Baltimore, MD',
          image: require('@/assets/images/testi1.webp')
        },
        {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.',
          name: 'Erica B.',
          address: 'San Antonio, TX',
          image: require('@/assets/images/testi3.webp')
        },
        {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare.',
          name: 'Mary J.',
          address: 'New York, NY',
          image: require('@/assets/images/testi2.webp')
        }
      ]
    }
  },

  methods: {
    ...mapActions([
      'setCartVisibility',
      'addToCart'
    ]),

    getOrdinalSuffix(day) {
      if (day >= 11 && day <= 13) return 'th'
      switch (day % 10) {
        case 1: return 'st'
        case 2: return 'nd'
        case 3: return 'rd'
        default: return 'th'
      }
    },

    formatPriceDollars(price) {
      return Math.floor(price)
    },

    formatPriceCents(price) {
      const cents = Math.round((price % 1) * 100)
      return cents.toString().padStart(2, '0')
    },

    getPlanTitle(plan) {
      if (plan.terms === 1) return '1 Month'
      if (plan.terms === 3) return '3 Months'
      return plan.name
    },

    getPlanSubtitle(plan) {
      if (plan.terms === 1) return 'Monthly Supply'
      if (plan.terms === 3) return 'Save More'
      return ''
    },

    calculateSavings(plan) {
      // Find the monthly plan for the same product
      const monthlyPlan = this.availablePlans.find(p => p.product === plan.product && p.terms === 1)
      if (!monthlyPlan) return '0'

      // Calculate what 3 months would cost at monthly price
      const monthlyTotal = monthlyPlan.price * 3
      // Calculate savings
      const savings = monthlyTotal - plan.price
      return savings.toFixed(2).replace(/\.00$/, '')
    },

    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },

    handleResize() {
      this.checkMobile()
    },

    getDailyPrice(price) {
      const daily = (parseFloat(price) / 30).toFixed(2)
      return `$${daily}`
    },

    getBenefitsRow(rowIndex) {
      if (!this.product?.benefits?.key_points) return []
      const start = rowIndex * 2
      return this.product.benefits.key_points.slice(start, start + 2)
    },

    getHowItWorksStack(stackIndex) {
      if (!this.product?.how_it_works?.steps) return []
      const start = stackIndex * 2
      return this.product.how_it_works.steps.slice(start, start + 2)
    },

    toggleDropdown(index) {
      this.openDropdown = this.openDropdown === index ? null : index
    },

    toggleDropdownDesktop(index) {
      this.openDropdownDesktop = this.openDropdownDesktop === index ? null : index
    },

    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },

    toggleCart() {
      this.$store.dispatch('setCartVisibility', !this.isCartOpen)
    },

    nextImage() {
      if (!this.productImages.length) return
      this.currentImageIndex = (this.currentImageIndex + 1) % this.productImages.length
    },

    previousImage() {
      if (!this.productImages.length) return
      this.currentImageIndex = this.currentImageIndex === 0
        ? this.productImages.length - 1
        : this.currentImageIndex - 1
    },

    goToImage(index) {
      this.currentImageIndex = index

      // Scroll thumbnail into view
      this.$nextTick(() => {
        const thumbnail = document.querySelector(`.gallery-link${index + 1}`)
        if (thumbnail) {
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
        }
      })
    },

    handleTouchStart(e) {
      if (!this.isMobile) return
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
      this.isDragging = false
      this.dragOffset = 0
    },

    handleTouchMove(e) {
      if (!this.isMobile) return

      const touchCurrentX = e.touches[0].clientX
      const touchCurrentY = e.touches[0].clientY
      const deltaX = touchCurrentX - this.touchStartX
      const deltaY = touchCurrentY - this.touchStartY

      // Only handle horizontal swipes (prevent vertical scroll interference)
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        e.preventDefault()
        this.isDragging = true
        this.dragOffset = deltaX
      }
    },

    handleTouchEnd() {
      if (!this.isMobile || !this.isDragging) {
        this.isDragging = false
        this.dragOffset = 0
        return
      }

      const swipeThreshold = 50 // Minimum distance to trigger slide change
      const deltaX = this.dragOffset

      if (Math.abs(deltaX) > swipeThreshold) {
        if (deltaX > 0) {
          // Swiped right - go to previous image
          this.previousImage()
        } else {
          // Swiped left - go to next image
          this.nextImage()
        }
      }

      // Reset dragging state
      this.isDragging = false
      this.dragOffset = 0
    },

    openLightbox(index) {
      this.currentImageIndex = index
      this.lightboxOpen = true
      document.body.style.overflow = 'hidden'
    },

    closeLightbox() {
      this.lightboxOpen = false
      document.body.style.overflow = ''
    },

    handleLightboxTouchStart(e) {
      this.lightboxTouchStartX = e.touches[0].clientX
      this.isLightboxDragging = false
      this.lightboxDragOffset = 0
    },

    handleLightboxTouchMove(e) {
      const touchCurrentX = e.touches[0].clientX
      const deltaX = touchCurrentX - this.lightboxTouchStartX

      if (Math.abs(deltaX) > 10) {
        e.preventDefault()
        this.isLightboxDragging = true
        this.lightboxDragOffset = deltaX
      }
    },

    handleLightboxTouchEnd() {
      if (!this.isLightboxDragging) {
        this.isLightboxDragging = false
        this.lightboxDragOffset = 0
        return
      }

      const swipeThreshold = 50
      const deltaX = this.lightboxDragOffset

      if (Math.abs(deltaX) > swipeThreshold) {
        if (deltaX > 0) {
          this.previousImage()
        } else {
          this.nextImage()
        }
      }

      this.isLightboxDragging = false
      this.lightboxDragOffset = 0
    },

    handleAddToCart() {
      if (!this.product) return

      // Use selected plan price if available, otherwise use product price
      const selectedPlan = this.selectedPlan
      const price = selectedPlan ? selectedPlan.price : this.product.pricing.retail_price
      const planName = selectedPlan ? this.getPlanTitle(selectedPlan) : ''

      const cartItem = {
        id: this.product.id,
        name: selectedPlan ? `${this.product.name} - ${planName}` : this.product.name,
        category: this.product.category,
        price: price,
        retail_price: this.oldPrice,
        subheader: this.product.brand_name,
        sku: this.product.sku,
        stripe_id: this.product.stripe_id,
        quantity: 1,
        image: this.productImages[0]?.url,
        main_type: this.product.is_prescription,
        plan_id: selectedPlan?.plan_id || null,
        terms: selectedPlan?.terms || 0
      }

      this.$store.dispatch('addToCart', cartItem)
    },

    addRelatedToCart(relatedProduct) {
      const cartItem = {
        id: relatedProduct.id,
        name: relatedProduct.name,
        category: relatedProduct.category,
        price: relatedProduct.pricing.retail_price,
        retail_price: (parseFloat(relatedProduct.pricing.retail_price) * 1.33).toFixed(2),
        subheader: relatedProduct.brand_name,
        sku: relatedProduct.sku,
        stripe_id: relatedProduct.stripe_id,
        quantity: 1,
        image: relatedProduct.images?.[0]?.url,
        main_type: relatedProduct.is_prescription
      }

      this.$store.dispatch('addToCart', cartItem)
    },

    async loadProduct() {
      try {
        this.isLoading = true
        this.selectedPlanId = null // Reset selected plan
        this.selectedSupply = 'monthly' // Reset supply selection
        const productUrlName = this.$route.params.productName

        await fetchProductsFromServer()
        const foundProduct = findProductByUrlName(productUrlName)

        if (foundProduct) {
          this.product = foundProduct
          this.error = null
          document.title = `${foundProduct.name} | NewSelf`
          this.updateMetaTags(foundProduct)
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          this.error = 'Product not found'
          // Debug: show what we're looking for vs what's available
          const { getProducts } = await import('@/utils/productData')
          const allProducts = getProducts()
          console.error('Product not found. Looking for:', productUrlName)
          console.log('Available URLs:', allProducts?.map(p => p.url))
          // Don't redirect - show error state instead so we can debug
        }
      } catch (error) {
        console.error('Error loading product:', error)
        this.error = 'Error loading product. Please try again.'
      } finally {
        this.isLoading = false
      }
    },

    updateMetaTags(product) {
      const metaDescription = document.querySelector('meta[name="description"]')
      if (metaDescription) {
        metaDescription.setAttribute('content', product.shop_page_description)
      }

      const ogTitle = document.querySelector('meta[property="og:title"]')
      const ogDescription = document.querySelector('meta[property="og:description"]')
      const ogImage = document.querySelector('meta[property="og:image"]')

      if (ogTitle) ogTitle.setAttribute('content', product.name)
      if (ogDescription) ogDescription.setAttribute('content', product.shop_page_description)
      if (ogImage && this.productImages[0]) ogImage.setAttribute('content', this.productImages[0].url)
    }
  },

  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.handleResize)
    this.loadProduct()

    // If in modal mode, prevent body horizontal scroll
    if (this.isInModal) {
      document.body.style.overflowX = 'hidden'
      document.documentElement.style.overflowX = 'hidden'
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)

    // Clean up modal mode body styles
    if (this.isInModal) {
      document.body.style.overflowX = ''
      document.documentElement.style.overflowX = ''
    }
  },

  watch: {
    '$route'(to, from) {
      if (to.params.productName !== from.params.productName) {
        this.loadProduct()
      }
    },
    availablePlans: {
      immediate: true,
      handler(plans) {
        // Auto-select the 3-month plan by default (best value option)
        if (plans && plans.length > 0 && !this.selectedPlanId) {
          // Prefer the 3-month plan (terms === 3)
          const threeMonthPlan = plans.find(p => p.terms === 3)
          this.selectedPlanId = threeMonthPlan ? threeMonthPlan.plan_id : plans[0].plan_id
        }
      }
    }
  }
}
</script>
<style>
.image-418-logo{
  height: 45px;
}

/* Pricing Selection Styles */
.payplan-choice.selected {
  border: 2px solid #e9ff86;
  background-color: rgba(233, 255, 134, 0.1);
}

.payplan-choice {
  cursor: pointer;
  transition: all 0.2s ease;
}

.payplan-choice:hover {
  border-color: #e9ff86;
}

.radio-button-4.w-radio-input:checked {
  border-color: #e9ff86;
  background-color: #e9ff86;
}



.div-block-2302 {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    display: flex;
}

/* Mobile Image Scroll Styles */
.slides-container {
  display: flex;
}

@media screen and (max-width: 768px) {
  .mask-13.mobile-scroll {
    width: 70%;
    overflow: visible !important;
  }

  .mask-13.mobile-scroll .product-slide {
    width: 100%;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .mask-13.mobile-scroll .product-slide.template {
    width: 100%;
  }

  .product-slider {
    overflow: hidden;
    margin-bottom: 0;
  }

  .product-slider-right-arrow,
  .product-slider-left-arrow {
    display: none;
  }

  .product-img-div.template {
    flex-flow: column;
    width: auto;
    min-width: 0;
    overflow: visible;
  }
}

/* Mobile Lightbox Styles */
.mobile-lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.lightbox-close-btn {
  position: absolute;
  top: 70px;
  right: 15px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;
  z-index: 10001;
  padding: 5px 12px;
  line-height: 1;
  border-radius: 50%;
}

.lightbox-counter {
  position: absolute;
  top: 75px;
  left: 20px;
  color: white;
  font-size: 14px;
  z-index: 10001;
}

.lightbox-swipe-container {
  width: 100%;
  height: 70%;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.lightbox-slides {
  display: flex;
  height: 100%;
  width: 100%;
}

.lightbox-slide {
  min-width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.lightbox-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.lightbox-dots {
  position: absolute;
  bottom: 30px;
  display: flex;
  gap: 10px;
  z-index: 10001;
}

.lightbox-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.lightbox-dot.active {
  background-color: #e9ff86;
}

/* How It Works - Equal width cards */
.div-block-2158 {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.div-block-2158 .hiw_-stack {
  flex: 1 1 calc(50% - 8px);
  min-width: 300px;
}

.process-box-copy {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .div-block-2158 .hiw_-stack {
    flex: 1 1 100%;
  }
}

/* Modal Mode Styles - Applied when embedded in iframe with modal=true */
.modal-mode {
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

.modal-mode * {
  box-sizing: border-box;
}

.modal-mode .product-section {
  padding-top: 0;
}

.modal-mode .product-div-wrap {
  padding: 20px;
  max-width: 100%;
  overflow-x: hidden;
}

.modal-mode .product-div-box {
  gap: 24px;
}

.modal-mode .product-images-div {
  max-width: 100%;
}

.modal-mode .highlights_wrap,
.modal-mode .dropdowns-div-wrap,
.modal-mode .how-it-works-wrap,
.modal-mode .table-wrap {
  padding-left: 20px;
  padding-right: 20px;
  max-width: 100%;
  overflow-x: hidden;
}

/* Prevent horizontal scroll from any wide elements */
.modal-mode section {
  max-width: 100%;
  overflow-x: hidden;
}

.modal-mode .table-div {
  max-width: 100%;
  overflow-x: auto;
}

.modal-mode .comparison-table {
  min-width: 0;
}

/* Mobile adjustments for modal */
@media screen and (max-width: 768px) {
  .modal-mode .product-div-wrap {
    padding: 12px;
  }

  .modal-mode .product-div-box {
    flex-direction: column;
  }

  .modal-mode .product-images-div {
    width: 100%;
  }

  .modal-mode .product-detail-div {
    width: 100%;
    padding: 0;
  }
}
</style>